import { render, staticRenderFns } from "./ClassPerformingRanking.vue?vue&type=template&id=4da88040&scoped=true"
import script from "./ClassPerformingRanking.vue?vue&type=script&lang=js"
export * from "./ClassPerformingRanking.vue?vue&type=script&lang=js"
import style0 from "./ClassPerformingRanking.vue?vue&type=style&index=0&id=4da88040&prod&scoped=true&lang=css"
import style1 from "./ClassPerformingRanking.vue?vue&type=style&index=1&id=4da88040&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da88040",
  null
  
)

export default component.exports